import { render, staticRenderFns } from "./SlideshowSliderAltParallax.vue?vue&type=template&id=95519fc4&scoped=true&"
import script from "./SlideshowSliderAltParallax.vue?vue&type=script&lang=js&"
export * from "./SlideshowSliderAltParallax.vue?vue&type=script&lang=js&"
import style0 from "./SlideshowSliderAltParallax.vue?vue&type=style&index=0&id=95519fc4&lang=scss&scoped=true&"
import style1 from "./SlideshowSliderAltParallax.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95519fc4",
  null
  
)

export default component.exports